import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { CouponService } from 'src/app/services/coupon.service';
import { CartItem } from 'src/app/entities/cart-item';
import { Transaction } from 'src/app/entities/transaction';
import { Product } from 'src/app/entities/product';
import { AlertService } from 'src/app/services/alert.service';

declare var feather: any;

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent implements OnInit {
  
  cart = new Array<CartItem>();
  transaction = new Transaction();
  
  // Coupon fields
  couponCode = '';
  couponAmount = 0;
  couponApplied = false;
  couponLoading = false;

  constructor(
    protected cartService: CartService,
    protected transactionService: TransactionService,
    protected couponService: CouponService,
    protected alertService: AlertService
  ) { }

  ngOnInit() {
    this.loadCart();
    this.loadTransaction();
    this.configDelivery();
    this.configDiscounts();
    this.configInstallments();
    
    // Load coupon from transaction if it exists
    if (this.transactionService.transactionCurrent.coupon_code) {
      this.couponCode = this.transactionService.transactionCurrent.coupon_code;
      this.couponAmount = this.transactionService.transactionCurrent.coupon_amount || 0;
      this.couponApplied = true;
    }
    
    // Initialize Feather icons
    setTimeout(() => {
      if (typeof feather !== 'undefined') {
        feather.replace();
      }
    }, 0);
  }

  loadCart() {
    this.cartService.items.subscribe(data => {
      this.cart = data;
    });
  }

  loadTransaction() {
    this.transaction = this.transactionService.transactionCurrent;
    this.transaction.discount_payment = 0;
  }

  configDiscounts() {
    this.transactionService.paymentDiscount.subscribe(percent => {
      this.transaction.discount_payment = percent;
    });
  }

  configInstallments() {
    this.transactionService.paymentInstallment.subscribe(installment => {
      this.transaction.installment = installment;
    });
  }

  configDelivery() {
    this.transactionService.currentDelivery.subscribe(data => {
      if (data) {
        this.transaction.additional = parseFloat(data.price);
      } else {
        this.transaction.additional = 0;
      }
    });
  }

  getAdditionalProcessed() {
    let total = parseFloat(this.transaction.additional);
    if(this.transaction.installment != undefined && this.transaction.installment != null && this.transaction.installment['percent'] != undefined){
      total = (((this.getTotalProcessed() + parseFloat(this.transaction.additional)) * (parseFloat(this.transaction.installment.percent)/100))) + parseFloat(this.transaction.additional);
    }
    return total;
  }

  getDiscountProcessed() {
    if(this.transaction.discount_payment == 0){
      return this.transaction.discount;
    }
    let total = parseFloat(this.transaction.discount);
    total += (this.transaction.total * (this.transaction.discount_payment/100));
    return total;
  }

  getTotalProcessed() {
    if (this.transaction.discount_payment == 0) {
      return this.transaction.total;
    }
    let total = parseFloat(this.transaction.total);
    total -= (this.transaction.total * (this.transaction.discount_payment/100));

    return total;
  }

  getPrice(item: Product) {
    return Product.getPrice(item);
  }

  getPriceWithoutDiscount(item: Product) {
    return Product.getPriceWithoutDiscount(item);
  }

  getDiscount(item: Product) {
    return Product.getDiscount(item);
  }

  getStock(item: Product) {
    return Product.getStock(item);
  }

  applyCoupon() {
    if (!this.couponCode || this.couponCode.trim() === '') {
      this.alertService.showError('Error', 'Por favor ingrese un código de cupón');
      return;
    }

    this.couponLoading = true;
    this.couponService.preview(this.couponCode.trim(), this.cartService.fingerprintCurrent).subscribe(
      data => {
        this.couponLoading = false;
        if (data.success && data.response && data.response.valid) {
          this.couponApplied = true;
          this.couponAmount = data.response.amount;
          this.couponCode = data.response.code;
          
          // Save coupon to transaction object
          this.transactionService.transactionCurrent.coupon_code = data.response.code;
          this.transactionService.transactionCurrent.coupon_amount = data.response.amount;
          
          this.transactionService.appliedCoupon.next({ code: data.response.code, amount: data.response.amount });
          this.alertService.showSuccess('¡Cupón aplicado!', `Ahorrarás $${this.couponAmount.toLocaleString('es-AR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`);
          // Re-initialize feather icons for the new tag icon
          setTimeout(() => {
            if (typeof feather !== 'undefined') {
              feather.replace();
            }
          }, 0);
        } else {
          // Handle error from response
          const errorMessage = data.response?.error || data.error?.message || 'El cupón no es válido o ha expirado';
          this.alertService.showError('Cupón inválido', errorMessage);
        }
      },
      error => {
        this.couponLoading = false;
        // Handle HTTP errors
        const errorMessage = error.error?.error?.message || error.error?.message || 'No se pudo validar el cupón. Intente nuevamente.';
        this.alertService.showError('Error', errorMessage);
      }
    );
  }

  removeCoupon() {
    this.couponCode = '';
    this.couponAmount = 0;
    this.couponApplied = false;
    
    // Clear coupon from transaction object
    this.transactionService.transactionCurrent.coupon_code = undefined;
    this.transactionService.transactionCurrent.coupon_amount = undefined;
    
    this.transactionService.appliedCoupon.next(null);
    // Re-initialize feather icons after DOM update
    setTimeout(() => {
      if (typeof feather !== 'undefined') {
        feather.replace();
      }
    }, 0);
  }

  getFinalTotal() {
    return this.getTotalProcessed() + this.getAdditionalProcessed() - this.couponAmount;
  }

  getTotalDiscounts() {
    return this.getDiscountProcessed() + this.couponAmount;
  }
}
